import tracking from "frontend/tracking";
import consts from "shared/consts";

export function onUpgradeClickedOnMondayApp(event: string) {
  tracking.trackAnalyticsEvent(`canvas_monday_${event}`, { category: consts.TRACKING_CATEGORY.BILLING });
  window.open(`${process.env.APP_URL}#show=checkout`, "_blank");
}
